<div class="gray-overlay" [ngClass]="class">
  <div id="loader-overlay">
    <div id="loader">
      <img src="../assets/icons/loaderTransparent.gif" class="loader-gif" />
    </div>
  </div>
</div>
